import { render, staticRenderFns } from "./CardCadastroPedido.vue?vue&type=template&id=a897aa5e&scoped=true"
import script from "./CardCadastroPedido.vue?vue&type=script&lang=js"
export * from "./CardCadastroPedido.vue?vue&type=script&lang=js"
import style0 from "./CardCadastroPedido.vue?vue&type=style&index=0&id=a897aa5e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a897aa5e",
  null
  
)

export default component.exports